import * as React from 'react'
import { isMobile } from 'react-device-detect'
import { Col } from 'antd'
import { Dispatch } from 'redux'
import { connect } from 'react-redux'
import { DeliveryTrackingData } from '../../store/DeliveryTracking/types'
import { ApplicationState } from '../../store'
import styles from './AppHeader.module.scss'
import Container from '../../components/Container'

class AppHeader extends React.Component<AllProps, {}> {
  render() {
    const { deliveryData: { companyInfo: { template: { logoUrl } } } } = this.props
    const marginTop = isMobile ? 32 : 64

    return (
      <Container>
        { logoUrl && (
        <Col xs={24} style={{ marginTop }}>
          <img className={styles.companyLogo} src={logoUrl} alt="Logo" />
        </Col>
        ) }
      </Container>
    )
  }
}

interface PropsFromState {
  deliveryData: DeliveryTrackingData
}

interface PropsFromDispatch {

}

type AllProps = PropsFromState & PropsFromDispatch

const mapStateToProps = ({ containers }: ApplicationState) => ({
  deliveryData: containers.DeliveryTracking.deliveryData,
})

const mapDispatchToProps = (dispatch: Dispatch) => ({

})

export default connect(mapStateToProps, mapDispatchToProps)(AppHeader)
